export const createdByOptions = (option) => {
  return option?.userLoginName || option?.userName ?
    option?.userLoginName + ' - ' + option?.userName :
    '';
};


export const createForOptions = (option) => {
  return option?.userLoginName || option?.userName ?
    option?.userLoginName + ' - ' + option?.userName :
    '';
};
